import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import TeamPage from "./pages/TeamPage";
import Commits from "./pages/Commits";
import Showcase from "./pages/Showcase";
import Founders from "./pages/Founders";
import Advisors from "./pages/Advisors";
import Contact from "./pages/Contact";
import { AdminProvider, useAdmin } from "./context/AdminContext";
import { PlayerProvider, usePlayer } from "./context/PlayerContext";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminPlayers from "./pages/admin/AdminPlayers";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminCommits from "./pages/admin/AdminCommits";
import AdminShowcases from "./pages/admin/AdminShowcases";
import AdminStandouts from "./pages/admin/AdminStandouts";
import AdminProfiles from "./pages/admin/AdminProfiles";
import AdminShowcaseRegistrations from "./pages/admin/AdminShowcaseRegistrations";
import AdminVideos from "./pages/admin/AdminVideos";
import AdminPlayerAccounts from "./pages/admin/AdminPlayerAccounts";
import AdminTeamMedia from "./pages/admin/AdminTeamMedia";
import AdminPrograms from "./pages/admin/AdminPrograms";
import PlayerRegister from "./pages/player/PlayerRegister";
import PlayerLogin from "./pages/player/PlayerLogin";
import PlayerDashboard from "./pages/player/PlayerDashboard";
import PublicProfile from "./pages/player/PublicProfile";
import ForgotPassword from "./pages/player/ForgotPassword";
import ResetPassword from "./pages/player/ResetPassword";
import ClaimInvite from "./pages/player/ClaimInvite";

// Protected Route Component for Admin
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAdmin();
  
  if (loading) {
    return <div className="page-content"><p style={{ textAlign: 'center', padding: '100px 0' }}>Loading...</p></div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

// Protected Route Component for Players
const PlayerProtectedRoute = ({ children }) => {
  const { player, loading } = usePlayer();
  
  if (loading) {
    return <div className="page-content"><p style={{ textAlign: 'center', padding: '100px 0' }}>Loading...</p></div>;
  }
  
  return player ? children : <Navigate to="/player/login" />;
};

function App() {
  return (
    <div className="App">
      <AdminProvider>
        <PlayerProvider>
          <BrowserRouter>
            <Navigation />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/team/:team" element={<TeamPage />} />
              <Route path="/highschool/:team" element={<TeamPage />} />
              <Route path="/commits" element={<Commits />} />
              <Route path="/showcase" element={<Showcase />} />
              <Route path="/founders" element={<Founders />} />
              <Route path="/advisors" element={<Advisors />} />
              <Route path="/contact" element={<Contact />} />
              
              {/* Player Routes */}
              <Route path="/player/register" element={<PlayerRegister />} />
              <Route path="/player/login" element={<PlayerLogin />} />
              <Route path="/player/forgot-password" element={<ForgotPassword />} />
              <Route path="/player/reset-password" element={<ResetPassword />} />
              <Route path="/claim-invite/:token" element={<ClaimInvite />} />
              <Route path="/player/dashboard" element={<PlayerProtectedRoute><PlayerDashboard /></PlayerProtectedRoute>} />
              <Route path="/profile/:shareSlug" element={<PublicProfile />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/players" element={<ProtectedRoute><AdminPlayers /></ProtectedRoute>} />
              <Route path="/admin/contacts" element={<ProtectedRoute><AdminContacts /></ProtectedRoute>} />
              <Route path="/admin/commits" element={<ProtectedRoute><AdminCommits /></ProtectedRoute>} />
              <Route path="/admin/showcases" element={<ProtectedRoute><AdminShowcases /></ProtectedRoute>} />
              <Route path="/admin/standouts" element={<ProtectedRoute><AdminStandouts /></ProtectedRoute>} />
              <Route path="/admin/profiles" element={<ProtectedRoute><AdminProfiles /></ProtectedRoute>} />
              <Route path="/admin/showcase-registrations" element={<ProtectedRoute><AdminShowcaseRegistrations /></ProtectedRoute>} />
              <Route path="/admin/videos" element={<ProtectedRoute><AdminVideos /></ProtectedRoute>} />
              <Route path="/admin/player-accounts" element={<ProtectedRoute><AdminPlayerAccounts /></ProtectedRoute>} />
              <Route path="/admin/team-media" element={<ProtectedRoute><AdminTeamMedia /></ProtectedRoute>} />
              <Route path="/admin/programs" element={<ProtectedRoute><AdminPrograms /></ProtectedRoute>} />
            </Routes>
            <Footer />
          </BrowserRouter>
        </PlayerProvider>
      </AdminProvider>
    </div>
  );
}

export default App;
